import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "currencyMask",
})
export class CurrencyMaskPipe implements PipeTransform {
  transform(value: number | string): string {
    if (!value) {
      return "R$ 0,00";
    }

    const numberValue = typeof value === "string" ? parseFloat(value) : value;
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(numberValue);
  }
}
